import React, { useEffect, useRef } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useSchedule, useScheduleMask, useSchedulePanel } from '../../../hooks/schedule';
import { ScheduleDisplayInfo } from './ScheduleDisplayInfo';
import { ScheduleHeader } from './ScheduleHeader';
import { ScheduleTitleColumn } from './ScheduleTitleColumn';
import { ScheduleView } from './ScheduleView';
export function SchedulePanel(props) {
  var localeTitle = useLocale('schedule.title');
  var _props$title = props.title,
      title = _props$title === void 0 ? localeTitle : _props$title,
      renderDisplayInfo = props.renderDisplayInfo,
      renderTooltip = props.renderTooltip,
      colWidth = props.colWidth,
      onDisplayInfoChange = props.onDisplayInfoChange,
      renderEmpty = props.renderEmpty,
      disabled = props.disabled;
  var boxRef = useRef(null);
  var cls = usePrefixCls('schedule-panel');
  var wrapperCls = usePrefixCls('schedule-panel-wrapper');
  var contentCls = usePrefixCls('schedule-panel-content');
  var viewBoxCls = usePrefixCls('schedule-panel-view-box');
  var maskCls = usePrefixCls('schedule-panel-view-mask');

  var _useSchedulePanel = useSchedulePanel(),
      datasource = _useSchedulePanel.datasource,
      displayInfo = _useSchedulePanel.displayInfo,
      scheduleList = _useSchedulePanel.scheduleList,
      onClearAll = _useSchedulePanel.onClearAll,
      onSetValue = _useSchedulePanel.onSetValue;

  var schedule = useSchedule();
  var onDisplayInfoChangeCallback = useRefCallback(onDisplayInfoChange);
  useEffect(function () {
    var change = function change() {
      onDisplayInfoChangeCallback(schedule.getDisplayInfo());
    };

    schedule.addListener('value-change', change);
    return function () {
      schedule.removeListener('value-change', change);
    };
  }, []);

  var _useScheduleMask = useScheduleMask(boxRef, 'schedule-mask', true),
      maskRelativeRect = _useScheduleMask.maskRelativeRect,
      dragging = _useScheduleMask.dragging;

  var maskStyle = function maskStyle() {
    var style = {
      display: dragging && maskRelativeRect ? 'block' : 'none'
    };

    if (!(dragging && maskRelativeRect)) {
      return style;
    }

    style.top = "".concat(maskRelativeRect.top, "px");
    style.bottom = "".concat(maskRelativeRect.bottom, "px");
    style.left = "".concat(maskRelativeRect.left, "px");
    style.right = "".concat(maskRelativeRect.right, "px");
    return style;
  };

  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: wrapperCls
  }, React.createElement(ScheduleTitleColumn, {
    title: title,
    datasource: datasource
  }), React.createElement("div", {
    className: contentCls
  }, React.createElement(ScheduleHeader, null), React.createElement("div", {
    className: viewBoxCls,
    ref: boxRef
  }, React.createElement(ScheduleView, {
    scheduleList: scheduleList,
    onSetValue: onSetValue,
    renderTooltip: renderTooltip,
    colWidth: colWidth,
    disabled: disabled
  }), React.createElement("div", {
    className: maskCls,
    style: maskStyle()
  })))), React.createElement(ScheduleDisplayInfo, {
    displayInfo: displayInfo,
    onClearAll: onClearAll,
    renderDisplayInfo: renderDisplayInfo,
    renderEmpty: renderEmpty,
    disabled: disabled
  }));
}